import {AfterViewChecked, Component, OnDestroy, OnInit} from '@angular/core';
import {MyNotDeviceRequestContainerModel} from '../../models/my-not-device-request-container.model';
import {of, Subject, Subscription} from 'rxjs';
import {EditModalService} from '../../services/edit-modal.service';
import {ModalVisibilityService} from '../../services/modal-visibility.service';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {MyContainersTableIdEnum} from '../../enums/my-containers-table-id.enum';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

// tslint:disable:max-line-length
@Component({
    selector: 'app-add-additional-item-to-order-modal',
    templateUrl: './add-additional-item-to-order-modal.component.html',
    styleUrls: ['./add-additional-item-to-order-modal.component.scss']
})
export class AddAdditionalItemToOrderModalComponent extends ModalDialogV3 implements OnInit, OnDestroy, AfterViewChecked {

    private changedContainers = [];

    public containers: MyNotDeviceRequestContainerModel[];
    public filteredAccessoryContainers: MyNotDeviceRequestContainerModel[];

    public searchPhrase: string;
    public lowerCaseActiveSearchPhrase: string;

    private searchTerm = new Subject<string>();
    private searchTermSub: Subscription;

    private isSpinnerHideden = false;


    public isFilterValueChanged = false;
    private parentTableId: MyContainersTableIdEnum;

    constructor(public editModalService: EditModalService,
                private modalVisibilityService: ModalVisibilityService
    ) {
        super();
    }

    public async ngOnInit() {
        this.parentTableId = this.modalParams.model['parentTableId'];
        this.init(this.parentTableId);
        this.searchTermSub = this.searchTerm.asObservable().pipe(
            debounceTime(400),
            distinctUntilChanged(),
            switchMap((value) => of(value))
        ).subscribe(searchPhrase => this.applyFilter(searchPhrase));

    }

    ngAfterViewChecked(): void {
        if (!this.isSpinnerHideden) {
            if (this.modalParams.model['hideSpinner']) {
                this.editModalService.announceActiveSpinnerIdChange(null);
            }
            this.isSpinnerHideden = true;
        }
    }

    public init(contentMode: MyContainersTableIdEnum) {


        const dialogModel = this.editModalService.getDialogModel();
        switch (contentMode) {
            case MyContainersTableIdEnum.step4AccessoriesTableContainers:
                this.containers = dialogModel.availableAccessoryContainers;
                break;
            case MyContainersTableIdEnum.step4WarrantiesTableContainers:
                this.containers = dialogModel.availableWarrantyContainers;
                break;
            case MyContainersTableIdEnum.step4ServicesContainers:
                console.error('Services mode is not implemented yet');
                break;
            case MyContainersTableIdEnum.step4UpgradesContainers:
                this.containers = dialogModel.availableUpgradesContainers;
                break;
            default:
                console.error('AddAdditionalItemToOrderModalComponent - unexpected contentMode', MyContainersTableIdEnum[contentMode], contentMode);
        }

        this.containers = this.containers.filter(container => container.itemToOrder.visibleToChannelPartners !== false);

        this.filteredAccessoryContainers = this.containers;
    }


    public getTitle(): string {
        switch (this.parentTableId) {
            case MyContainersTableIdEnum.step4AccessoriesTableContainers:
                return 'Zubehör hinzufügen';
            case MyContainersTableIdEnum.step4WarrantiesTableContainers:
                return 'Full Service Pack hinzufügen';
            case MyContainersTableIdEnum.step4ServicesContainers:
                return 'Services hinzufügen';
            case MyContainersTableIdEnum.step4UpgradesContainers:
                return 'Upgrades hinzufügen';
            default:
                console.error('AddAdditionalItemToOrderModalComponent - unexpected contentMode', MyContainersTableIdEnum[this.parentTableId], this.parentTableId);
                return '';
        }
    }

    public onCancelBtnClicked() {
        if (this.changedContainers.length) {
            this.announceModelChanged({action: 'RESET', containers: this.changedContainers});
        }
        this.close();
    }

    public onSubmitBtnClicked() {
        this.announceModelChanged({action: 'SUBMIT', containers: null});
        this.close();
    }


    public onSubItemCheckboxClicked(accessoryContainer: MyNotDeviceRequestContainerModel) {
        this.changedContainers.push(accessoryContainer);
    }


    private applyFilter(searchPhrase?: string) {

        // console.log('searchPhrase', searchPhrase);

        this.modalVisibilityService.announceCloseEditDialogModalsRequest('applyFilter');
        this.isFilterValueChanged = false;

        this.lowerCaseActiveSearchPhrase = searchPhrase && searchPhrase.trim().toLowerCase();

        if (!!this.lowerCaseActiveSearchPhrase) {
            this.filteredAccessoryContainers = this.containers.filter(
                ac => this.containerMatchTextSearchCriteria(ac));
        } else {
            this.filteredAccessoryContainers = this.containers;
        }


    }

    private containerMatchTextSearchCriteria(container: MyNotDeviceRequestContainerModel): boolean {
        return !this.lowerCaseActiveSearchPhrase ||
            // tslint:disable-next-line:max-line-length
            (container.itemToOrder.modelTitle && container.itemToOrder.modelTitle.toLowerCase().indexOf(this.lowerCaseActiveSearchPhrase) > -1) ||
            (container.itemToOrder.sku && container.itemToOrder.sku.toLowerCase().indexOf(this.lowerCaseActiveSearchPhrase) > -1) ||
            (container.itemToOrder.modelNumber && container.itemToOrder.modelNumber.toLowerCase().indexOf(this.lowerCaseActiveSearchPhrase) > -1);
    }

    public announceSearchTermChanged(term: string) {
        this.searchTerm.next(term);
    }

    public ngOnDestroy(): void {
        if (this.searchTermSub) {
            this.searchTermSub.unsubscribe();
        }

    }
}
